import React, { useEffect, useState } from "react";
import { Row, Col, Container } from "reactstrap";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { Link, useNavigate } from "react-router-dom";
import MachineDetails from "./CardInfo";
import "./CSS/Details.css";
import CSSImages from "./CSSImages";
import EBMImages from "./EBMImages";
import UBSImages from "./UBSImages";
const Details = () => {
  const [machine_card_details, setMachineCardDetails] = useState();
  const [imageUrls, setImageUrls] = useState();
  const [station, setStation] = useState();
  const [showAccessDenied, setShowAccessDenied] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    let details = JSON.parse(sessionStorage.getItem("rowData"));
    let station = sessionStorage.getItem("selected_station");
    let user = sessionStorage.getItem("user");
    let pwd = sessionStorage.getItem("pwd");
    let selected_title = sessionStorage.getItem("selectedTitle");
    if (user && pwd) {
      setShowAccessDenied(false);
      setStation(station);
      let machineDetails = {};
      if (selected_title === "ALL") {
        machineDetails = {
          model: details.model,
          date: details.formatted_date,
          bin: details.bin_no,
          time: details.formatted_time,
          shift: details.shift,
          status: details.status,
          Parts: details.results?.[station]?.result?.Parts || [],
          Parts_Keys: details.results?.[station]?.result?.Parts
            ? Object.keys(details.results?.[station]?.result?.Parts) || []
            : [],
        };
      } else {
        machineDetails = {
          model: details.model,
          date: details.formatted_date,
          bin: details.bin_no,
          time: details.formatted_time,
          shift: details.shift,
          status: details.status,
          Parts: details.result?.Parts || [],
          Parts_Keys: details.result?.Parts
            ? Object.keys(details.result?.Parts) || []
            : [],
        };
      }
      setMachineCardDetails(machineDetails);
      if (station === "K#EBM" || station === "EBM") {
        const z101ImageUrls = {
          LH_Fender: "../images/EBM/Z101/LH_Fender.png",
          LH_Front_Door: "../images/EBM/Z101/LH_Front_Door.png",
          LH_Rear_Door: "../images/EBM/Z101/LH_Rear_Door.png",
          BSO_LH: "../images/EBM/Z101/BSO_LH.png",
          RH_Fender: "../images/EBM/Z101/RH_Fender.png",
          RH_Front_Door: "../images/EBM/Z101/RH_Front_Door.png",
          RH_Rear_Door: "../images/EBM/Z101/RH_Rear_Door.png",
          BSO_RH: "../images/EBM/Z101/BSO_RH.png",
          Hood: "../images/EBM/Z101/Hood.png",
          Roof: "../images/EBM/Z101/Roof.png",
          Tail_Gate: "../images/EBM/Z101/Tail_Gate.png",
        };

        const w601ImageUrls = {
          LH_Fender: "../images/EBM/W601/LH_Fender.png",
          LH_Front_Door: "../images/EBM/W601/LH_Front_Door.png",
          LH_Rear_Door: "../images/EBM/W601/LH_Rear_Door.png",
          BSO_LH: "../images/EBM/W601/BSO_LH.png",
          RH_Fender: "../images/EBM/W601/RH_Fender.png",
          RH_Front_Door: "../images/EBM/W601/RH_Front_Door.png",
          RH_Rear_Door: "../images/EBM/W601/RH_Rear_Door.png",
          BSO_RH: "../images/EBM/W601/BSO_RH.png",
          Hood: "../images/EBM/W601/Hood.png",
          Roof: "../images/EBM/W601/Roof.png",
          Tail_Gate: "../images/EBM/W601/Tail_Gate.png",
        };

        // Update the imageUrls based on the model
        if (details.model === "Z101") {
          setImageUrls(z101ImageUrls);
        } else {
          setImageUrls(w601ImageUrls);
        }
      } else if (station === "K#UBS" || station === "UBS") {
        const z101ImageUrls = {
          Rear_LH: "../images/UBS/Z101/Rear_LH.png",
          Rear_RH: "../images/UBS/Z101/Rear_RH.png",
          Front_LH: "../images/UBS/Z101/Front_LH.png",
          Front_RH: "../images/UBS/Z101/Front_RH.png",
          Vehicle_Underbody: "../images/UBS/Z101/Vehicle_Underbody.png",
        };

        const w601ImageUrls = {
          Rear_LH: "../images/UBS/W601/Rear_LH.png",
          Rear_RH: "../images/UBS/W601/Rear_RH.png",
          Front_LH: "../images/UBS/W601/Front_LH.png",
          Front_RH: "../images/UBS/W601/Front_RH.png",
          Vehicle_Underbody: "../images/UBS/W601/Vehicle_Underbody.png",
        };

        if (details.model === "Z101") {
          setImageUrls(z101ImageUrls);
        } else {
          setImageUrls(w601ImageUrls);
        }
      } else if (station === "K#CSS" || station === "CSS") {
        const z101ImageUrls = {
          Bottom_Tail_Lamps_LH_RH:
            "../images/CSS/Z101/Bottom_Tail_Lamps_LH_RH.png",
          Hinge_Swing_Gate: "../images/CSS/Z101/Hinge_Swing_Gate.png",
          Roof: "../images/CSS/Z101/Roof.png",
          Top_Tail_Lamp_LH: "../images/CSS/Z101/Top_Tail_Lamp_LH.png",
          Top_Tail_Lamp_RH: "../images/CSS/Z101/Top_Tail_Lamp_RH.png",
        };

        const w601ImageUrls = {
          Pillar_Lower_LH: "../images/CSS/W601/Pillar_Lower_LH.png",
          Pillar_Lower_RH: "../images/CSS/W601/Pillar_Lower_RH.png",
          Pillar_Upper_LH: "../images/CSS/W601/Pillar_Upper_LH.png",
          Pillar_Upper_RH: "../images/CSS/W601/Pillar_Upper_RH.png",
          Rear_Header_Outer_Panel_Top_Side:
            "../images/CSS/W601/Rear_Header_Outer_Panel_Top_Side.png",
          Roof: "../images/CSS/W601/Roof.png",
        };

        if (details.model === "Z101") {
          setImageUrls(z101ImageUrls);
        } else {
          setImageUrls(w601ImageUrls);
        }
      }
    }
  }, []);
  return (
    <>
      {showAccessDenied ? (
        <>
          {" "}
          <Row className="justify-content-center text-center">
            <h4 className="access-denied-text">Access Denied</h4>
          </Row>
        </>
      ) : (
        <>
          <Row>
            {/* Back Button */}
            <Col
              xs={2}
              sm={2}
              md={1}
              lg={1}
              xl={1}
              xxl={1}
              className="d-flex align-items-center"
            >
              <Link
                to="/Stations"
                className="Color mx-3"
                onClick={() => {
                  sessionStorage.removeItem("rowData");
                  sessionStorage.removeItem("selected_station");
                }}
              >
                <ArrowBackIcon
                  style={{ fontSize: "2rem", cursor: "pointer" }}
                />
              </Link>
            </Col>

            {/* Machine Details */}
            <Col xs={12} sm={8} md={10} lg={10} xl={10} xxl={10}>
              <MachineDetails machineCardDetails={machine_card_details} />
            </Col>

            {/* Home Button */}
            <Col
              xs={2}
              sm={2}
              md={1}
              lg={1}
              xl={1}
              xxl={1}
              className="d-flex align-items-center justify-content-end"
            >
              <HomeOutlinedIcon
                style={{ fontSize: "3rem", cursor: "pointer" }}
                onClick={() => {
                  navigate(
                    `/Home?user=${sessionStorage.getItem(
                      "user"
                    )}&pwd=${sessionStorage.getItem("pwd")}`
                  );
                  // Add more code here if needed
                }}
              />
            </Col>
          </Row>
          {machine_card_details ? (
            <>
              {machine_card_details.status ? (
                <></>
              ) : (
                <Row className="d-flex text-center justify-content-center">
                  <h4 className="fs-2 no-defect">
                    <strong>No Defect Detected</strong>
                  </h4>
                </Row>
              )}

              <Row className="container-size">
                {(station === "K#EBM" || station === "EBM")   ? (
                  <EBMImages
                    model={machine_card_details.model}
                    imageUrls={imageUrls}
                    machine_card_details={machine_card_details}
                  />
                ) : (station === "K#UBS" || station === "UBS")   ? (
                  <UBSImages
                    model={machine_card_details.model}
                    imageUrls={imageUrls}
                    machine_card_details={machine_card_details}
                  />
                ) : (station === "K#CSS" || station === "CSS")  ? (
                  <CSSImages
                    machine_card_details={machine_card_details}
                    model={machine_card_details.model}
                    imageUrls={imageUrls}
                  />
                ) : (
                  <>
                    <Col xs={3} sm={3} md={3} lg={3} xl={3} xxl={3}></Col>
                    <Col
                      xs={6}
                      sm={6}
                      md={6}
                      lg={6}
                      xl={6}
                      xxl={6}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <span key="station-vacant" className="station_text">
                        No data available
                      </span>
                    </Col>
                    <Col xs={3} sm={3} md={3} lg={3} xl={3} xxl={3}></Col>
                  </>
                )}
              </Row>
            </>
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
};

export default Details;
